<template>
  <div class="Logado">
    <vr-toast :modelValue="toastList" :key="toastList"></vr-toast>
    <div class="container">
      <div class="row mt-2">
        <nav aria-label="breadcrumb" class="bg-light rounded">
          <ol class="breadcrumb small mt-2">
            <li class="breadcrumb-item">
              <a href="/" class="text-muted">{{ $t("home") }}</a>
            </li>
            <li class="breadcrumb-item active" aria-current="page">
              {{ $t("about") }}
            </li>
          </ol>
        </nav>
      </div>
      <div class="row">
        <div class="col-sm-12 col-md-12 col-lg-10 mx-auto">
          <vr-table-paginate
            :labels="labels"
            :list="list"
            :pageSize="10"
            :actionNew="openModalInsert"
            :actionEdit="openModalEdit"
            :actionDelete="openModalDelete"
            :btnNew="false"
            :actions="[
              {
                name: 'edit',
                class: 'btn btn-sm btn-warning',
                action: openModalEdit,
                ico: 'bi bi-pencil',
              },
            ]"
          ></vr-table-paginate>
        </div>
      </div>
    </div>
    
    <!-- Start Modal Edit -->
    <div class="modal fade" ref="editModal" tabindex="-1" aria-hidden="true">
      <div class="modal-dialog modal-xl">
        <div class="modal-content">
          <div v-if="deleteMode" class="modal-header bg-danger text-white">
            <h5 class="modal-title" id="editModalLabel">
              <i class="bi bi-eraser-fill"></i> {{ $t("delete") }}
              {{ $t("about") }}
            </h5>
            <a href="#" class="text-white" @click="modalEdit.hide()"
              ><i class="bi bi-x-lg"></i
            ></a>
          </div>
          <div v-if="!deleteMode" class="modal-header bg-warning">
            <h5 class="modal-title" id="editModalLabel">
              <i class="bi bi-pencil"></i> {{ $t("edit") }} {{ $t("about") }}
            </h5>
            <a href="#" class="text-dark" @click="modalEdit.hide()"
              ><i class="bi bi-x-lg"></i
            ></a>
          </div>
          <div class="modal-body">
            <nav aria-label="breadcrumb">
              <ol class="breadcrumb text-muted justify-content-end small">
                <li class="breadcrumb-item">
                  {{ $t("id") }}: <span class="badge bg-secondary">8</span>
                </li>
                <li class="breadcrumb-item">
                  {{ $t("dateInsert") }}:
                  <span class="badge bg-secondary">05/12/2021</span>
                </li>
              </ol>
            </nav>
            <form-edit-about
              :dataItem="formEdit"
              :actionSend="sendEdit"
              :errorServer="errorServer"
              :key="keyFormEditAbout"
              :ActionSendFile="sendFile"
              :deleteMode="deleteMode"
              :toastShow="toastShow"
            >
            </form-edit-about>
          </div>
        </div>
      </div>
    </div>
    <!-- End Modal Edit -->
    
    <!-- Start Modal Banner -->
    <div class="modal fade" ref="editBanner" tabindex="-1" aria-hidden="true">
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header bg-primary text-white">
            <h5 class="modal-title" id="editModalLabel">
              <i class="bi bi-boxes"></i> {{ $t("about") }} x
              {{ $t("banner") }}
            </h5>
            <a href="#" class="text-white" @click="modalBanner.hide()"
              ><i class="bi bi-x-lg"></i
            ></a>
          </div>
          <div class="modal-body">
            <form-banner-about
              :dataItem="formEdit"
              :errorServer="errorServer"
              :key="keyFormBannerAbout"
              :toastShow="toastShow"
            >
            </form-banner-about>
          </div>
        </div>
      </div>
    </div>
    <!-- End Modal Banner -->
    
  </div>
</template>

<script>
import AboutService from "../../../../services/about.service";
import AboutHandle from "../../../../services/handle/about.handle";
import FormEditAbout from "@/views/protected/pages/about/comp/formEditAbout.vue";
import FormBannerAbout from "@/views/protected/pages/about/comp/formBannerAbout.vue";

import { Modal } from "bootstrap";
import { getCurrentInstance } from "vue";
import VrToast from "../../../../components/VrToast.vue";
import VrTablePaginate from "../../../../components/VrTablePaginate.vue";

export default {
  name: "About",
  data: () => ({
    modalEdit: null,
    deleteMode: false,
    list: [],
    formEdit: {},
    keyFormEditAbout: "",
    keyFormBannerAbout: "",
    app: null,
    toastList: [],
    lengthPerPage: 0,
    atualPage: 1,
    labels: [],
  }),
  components: {
    VrToast,
    VrTablePaginate,
    FormEditAbout,
    FormBannerAbout
  },
  mounted() {
    this.app = getCurrentInstance();
    this.modalEdit = new Modal(this.$refs.editModal);
    this.modalBanner = new Modal(this.$refs.editBanner);

    this.labels = [
      { key: "id", type: "number" },
      { key: "title", type: "text" },
    ];
    this.reloadList();
  },
  methods: {
    reloadList: function () {
      AboutService.getAll().then((result) => {
        console.log(result);
        if (result.status >= 200 && result.status < 400) {
          // console.log(result.data);
          this.list = result.data;
        }
      }, this.errorServer);
    },
    openModalEdit: function (item) {
      AboutService.getOne(item.id).then((result) => {
        if (result.status >= 200 && result.status < 400) {
          this.formEdit = result.data;
          this.keyFormEditAbout = Math.random().toString(36).slice(2);
          this.deleteMode = false;
          this.modalEdit.show();
        }
      }, this.errorServer);
    },
    openModalDelete: function (item) {
      this.formEdit = item;
      this.modalEdit.show();
      this.deleteMode = true;
    },
    openModalBanner: function (item) {
      this.formEdit = item;
      this.keyFormBannerAbout = Math.random().toString(36).slice(2);
      this.modalBanner.show();
    },
    sendNew: function (objectForm) {
      //console.log(objectForm);
      AboutService.insert(AboutHandle.formToJso(objectForm)).then(
        (result) => {
          //console.log(result);
          result;
          this.cleanForm();
          this.toastShow({ msg: "O item foi inserido com Sucesso.", style: "success" });
        },
        this.errorServer
      );
    },
    sendEdit: function (objectForm) {
      this.cleanForm();
      this.toastShow({ msg: objectForm.msg, style: objectForm.style });
    },
    sendFile: function () {
      this.toastShow({ msg: "O arquivo foi alterado com Sucesso.", style: "success" });
    },
    cleanForm: function () {
      this.formInclude = {};
      this.deleteMode = false;
      this.modalEdit.hide();
      // this.toastList = []
      this.reloadList();
    },
    toastShow: function (alert) {
      this.toastList = [];
      this.toastList.push(alert);
    },
    errorServer: function (error) {
      console.log(error);
      this.toastShow({ msg: "Falha ao enviar dados (403)", style: "danger" });
      if (error.message.includes("403")) {
        this.app.appContext.config.globalProperties.$router.push("/login");
      }
    },
  },
};
</script>